/* eslint-disable no-unused-vars,react/no-unused-state */
import React from 'react';
import { connect } from 'react-redux';
import { withAppReady } from 'components/HOC/WithAppReady';
import { PageWrapper } from 'components/PageWrapper';
import {
  EnumShipShopeeStatus,
  ERROR_BOOKING_NOT_FOUND,
  ERROR_CODE_BOOKING_CANCEL,
  ERROR_SHARED_BOOKING_COMPLETED,
} from 'constants/enum';
import { MOCK } from 'constants/constant';
import { getOrderShopeeDetail } from './actions';
import { transformCommon2ShipStructure } from './data-transformer';
import { MOCK_SHIP_SHOPEE_DATA } from 'mock';
import { LoadingApp } from 'components/Loading/Loading';
import { Sidebar } from 'components/Sidebar';
import { ProcessingStep } from 'components/SideBlock/ProcessingStep';
import { ProcessingMap } from 'components/ProcessingMap';
import { ShippingAddress } from 'components/SideBlock/ShippingAddress';
import { ShipperInfo } from 'components/SideBlock/ShipperInfo';
import { OrderDetail } from 'components/SideBlock/OrderDetail';
import { BillInfo } from 'components/SideBlock/BillInfo';

class ShipShopeeTracking extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      isShowDetail: false,
      itemDetail: null,
      isProcessingCollapse: true,
      offsetYMap: 0,
      errorBooking: null,
      isCompleteBooking: null,
    };

    this.refProcessing = React.createRef();
  }

  componentDidMount () {
    this.handleGetOrderDetail();
    this.handleSetOffsetYMap();
  }

  componentWillUnmount () {
    clearTimeout(this.setOffsetYMapTimeout);
  }

  getOrderDetail = async () => {
    const { match, history } = this.props;
    const { params } = match;
    const { token } = params;
    // DEBUG
    if (MOCK) {
      return MOCK_SHIP_SHOPEE_DATA;
    }
    // 常规请求
    if (token) {
      try {
        const resp = await getOrderShopeeDetail(token);
        const itemDetail = transformCommon2ShipStructure(resp);
        if (itemDetail) {
          return itemDetail;
        }
      } catch (error) {
        if (error === ERROR_CODE_BOOKING_CANCEL) {
          this.setState({
            errorBooking: error,
          });
        } else if (error === ERROR_SHARED_BOOKING_COMPLETED) {
          this.setState({
            isCompleteBooking: true,
          });
        } else if (error === ERROR_BOOKING_NOT_FOUND) {
          history.push('/');
        }
        return null;
      }
    }
    // 无 token
    history.push('/');
    return null;
  };

  handleGetOrderDetail = async () => {
    const itemDetail = await this.getOrderDetail();
    if (itemDetail) {
      this.setState({ itemDetail });
    } else {
      this.setState({ itemDetail: null });
    }
  };

  handleSetOffsetYMap = () => {
    clearTimeout(this.setOffsetYMapTimeout);
    if (this.refProcessing.current) {
      this.setOffsetYMapTimeout = setTimeout(() => {
        this.setState({
          offsetYMap: this.refProcessing.current.getHeight(),
        });
      }, 500);
    }
  };

  handleZoomMapByStatus = (status) => {
    const { driverLocation } = this.state;
    const { itemDetail } = this.state;
    const { pick_address_info: pickAddressInfo, drop_address_info: dropAddressInfo } = itemDetail;
    const pickLocation = {
      lat: pickAddressInfo.latitude,
      lng: pickAddressInfo.longitude,
    };
    const dropLocation = {
      lat: dropAddressInfo.latitude,
      lng: dropAddressInfo.longitude,
    };
    switch (status) {
      case EnumShipShopeeStatus.ASSIGNING: {
        return [pickLocation];
      }
      case EnumShipShopeeStatus.ASSIGNED: {
        return [driverLocation, pickLocation];
      }
      case EnumShipShopeeStatus.PICKUP: {
        return [driverLocation, dropLocation];
      }
      default:
        return [pickLocation, dropLocation];
    }
  };

  render () {
    const {
      itemDetail,
      offsetYMap,
    } = this.state;

    if (!itemDetail) {
      return (
        <LoadingApp loading />
      );
    }

    const {
      status,
      pick_address_info: pickAddressInfo,
      drop_address_info: dropAddressInfo,
      driver_location: rawDriverLocation,
    } = itemDetail;

    const driverLocation = rawDriverLocation
      ? {
        lat: rawDriverLocation.latitude,
        lng: rawDriverLocation.longitude,
        heading: rawDriverLocation.heading,
      }
      : {};

    return (
      <PageWrapper>
        <ProcessingMap
          status={status}
          isNowShipService={false}
          offsetYMap={offsetYMap}
          pickAddressInfo={pickAddressInfo}
          dropAddressInfo={dropAddressInfo}
          driverLocation={driverLocation}
          onZoomMapByStatus={this.handleZoomMapByStatus}
        />
        <Sidebar>
          <ProcessingStep data={itemDetail} />
          <ShipperInfo data={itemDetail} />
          <ShippingAddress data={itemDetail} />
          <OrderDetail data={itemDetail} />
          <BillInfo data={itemDetail} />
        </Sidebar>
      </PageWrapper>
    );
  }
}

export default connect()(withAppReady(ShipShopeeTracking));
